export default __webpack_public_path__ + "static/media/12-sol-de-hoy.48081f23.png";